module.exports = __webpack_public_path__ + "static/other/organize_desk_game_desk_4.2e74cbde.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/organizeDeskGame/organize_desk_game_desk_4.json
// module id = 2352
// module chunks = 0